import React from 'react';
import Container from "@material-ui/core/Container";
import ColAtm from "../../../../atomic/Col/Col";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {withStyles} from "@material-ui/core";
import FactBoxs from "./AddonBoxes";
import FactHeader from "./AddonHeader";

let t=null;

const styles = theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    menuLinks: {
        height: '40px',
        textAlign: 'center',
        color: '#e46a6b',
        background: '#fae1e1',
    },
    aLink: {
        margin: 'auto',
        color: '#ffffff',
        fontSize: '14px',
        fontWeight: '500',
        "&:hover, &:focus": {
            color: '#eaeaea'
        },
    }
});

class Addons extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            accept_status : '',
            redirect: false,
            showSuccessHeader: false,
            checkedStatus: true
        }
        t = props.t;
    }


    render() {

        return (
            <>
                <FactHeader this_main_category={this.props.this_main_category} />
                <Container maxWidth="xl">
                    <div className="container-width fact-list">
                        <ColAtm>
                            <FactBoxs
                                get_addons={this.props.AddonsListData}
                                fetching={this.props.fetching}
                                pageId={this.props.pageId}
                                descriptionData={this.props.descriptionData}
                            />
                        </ColAtm>
                    </div>
                </Container>
            </>
        )
    }
}

export default compose(withTranslation('common'), withStyles(styles, { withTheme: true })) (Addons);
